import React from 'react';
import {withStyles} from '@material-ui/core/styles';

import Snackbar from '@material-ui/core/Snackbar';

export const StyledSnackbar = withStyles({
    root: {},
})(props => <Snackbar autoHideDuration={6000} {...props} />);
